// FirstAccessibleRedirect.tsx
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useMemo } from "react";
import { menus } from "../configure/sideDrawerMenus";

const FirstAccessibleRedirect = () => {
  const rolePermissions = useSelector(
    (state) => state.permission.applicationPermission || []
  );

  const findFirstAccessibleMenuRoute = (menus, rolePermissions) => {
    for (const menu of menus) {
      // Check if this menu is accessible
      if (menu.id === 402 && !menu.requiredPermissions?.every((perm) => rolePermissions.includes(perm)) && menu.requiredPermissions?.some((perm) => rolePermissions.includes(perm)) && rolePermissions.includes("rm_employee_profile_view")){
      const employeeid = localStorage.getItem("employeeId")
      return `/peoplelanding/profile/${employeeid}`
    }
      if (
        menu.requiredPermissions?.some((perm) =>
          rolePermissions.includes(perm)
        ) &&
        menu.to
      ) {
        return menu.to;
      }
      // If this menu has children, check recursively
      if (menu.items && Array.isArray(menu.items)) {
        const childRoute = findFirstAccessibleMenuRoute(
          menu.items,
          rolePermissions
        );
        if (childRoute) return childRoute;
      }
    }
    return null;
  };
  
  const firstAccessibleMenuRoute = useMemo(
    () =>
      findFirstAccessibleMenuRoute(menus, rolePermissions) ||
    "/permission-denied",
    [rolePermissions]
  );
  if(sessionStorage.getItem("postLoginRedirect")){
    const route = sessionStorage.getItem("postLoginRedirect");
    // sessionStorage.removeItem("postLoginRedirect");
    return <Navigate to={route} replace/>
  }else{
    return <Navigate to={firstAccessibleMenuRoute} replace />;
  }
};

export default FirstAccessibleRedirect;
